export default __webpack_public_path__ + "static/media/geodesy-cadastre-img.e972801e.jpg";